import { createRoot } from "react-dom/client";
import { AppStoresFactory } from "../shared-components/AppStoresFactory";
import { AppLegalFactory } from "./AppLegalFactory";
import { LegalComponent } from "./LegalComponent";
import { Fetcher } from "../util/io/Fetcher";
import type { LegalViewModelModel } from "../../OpenApi/api";
import React from "react";
import { OopsPageErrorCatchingComponent } from "../shared-components/error-catching-component/OopsPageErrorCatchingComponent";
import { SmoothLoadingComponent } from "../util/components/SmoothLoadingComponent";
import { InitialResourcesLoader, type IInitialResourcesLoader } from "../resources/InitialResourcesLoader";
import { redirectIfEolBrowser } from "../shared-components/configuration/EolBrowserGuard";

(async () => {
    if (redirectIfEolBrowser(window)) {
        return;
    }
    const rootElement: HTMLElement = document.getElementById("app-root")!;
    const root = createRoot(rootElement);

    // Show a loading indicator immediately so the user doesn't stare at a blank page while bootstrapping.
    root.render(<SmoothLoadingComponent />);

    try {
        const fetcher = new Fetcher();
        const appLegalFactory = new AppLegalFactory(new AppStoresFactory(fetcher, window));
        const viewModelUrl = rootElement.dataset.viewModelUrl!;

        // Kick off the resources fetch in parallel with the view-model. data-resources-url is always emitted
        // by the server (see ResourcesController.GetResourcesUrl); a missing value is a bug.
        const resourcesUrl = rootElement.dataset.resourcesUrl;
        if (!resourcesUrl) {
            throw new Error("data-resources-url is missing on the app-root element");
        }
        const initialResourcesLoader: IInitialResourcesLoader = InitialResourcesLoader.start(fetcher, resourcesUrl);

        const viewModel: LegalViewModelModel = await fetcher.getJSON<LegalViewModelModel>(viewModelUrl);
        const appLegal = await appLegalFactory.create(viewModel, initialResourcesLoader);

        root.render(<LegalComponent appLegal={appLegal} />);
    } catch (error) {
        root.render(<OopsPageErrorCatchingComponent error={error} isLandingPage={true} />);
    }
})();
